import { campaignActionTypes } from 'src/store/actions';
import { CampaignManagementState } from 'src/store/initial.state';

const initialState = new CampaignManagementState();
const campaignReducer = (state = initialState, action) => {
  const { type, payload } = action || {};
  switch (type) {
    case campaignActionTypes.GET_ALL_CAMPAIGNS:
      return { ...state, campaigns: payload.data };
    case campaignActionTypes.GET_CAMPAIGN_DETAILS:
      return { ...state, campaignDetails: payload.data };
    case campaignActionTypes.RESET_CAMPAIGN_DETAILS:
      return { ...state, campaignDetails: {} };
    case campaignActionTypes.GET_CATEGORY_STORE_LISTINGS:
      return { ...state, categoryTree: payload };
    case campaignActionTypes.SET_CATEGORY_TREE_LOADING:
      return { ...state, categoryTreeLoading: payload };
    default:
      return state;
  }
};

export { campaignReducer };
